import BorderedFilterItemCard from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterItemCard/BorderedFilterItemCard";
import { leadsDataSourceMap } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsFilterBuildContext";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";

import VisitsFromFilterResult from "../../components/filters/VisitsFromFilter/VisitsFromFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { defineLeadsFilter } from "../defineLeadsFilter";

import VisitsFromFilterModel from "./VisitsFromFilterModel";

// Permanent, always-open card with no expandable view; other filters depend on its "Worldwide" state, so it
// builds from `settingsService` alone (no data source).
export const visitsFromDefinition = defineLeadsFilter({
    key: "countries",
    apiCategory: leadsFilterApiCategory.countries,
    category: [leadsFilterCategoryMap.trafficAndEngagement, leadsFilterCategoryMap.advertiserActivity],
    trackingName: "Visits from",
    titleKey: { key: leadsSearchFiltersI18nKeys.filterGroupTitle("countries") },
    seedsDefault: () => true,
    requires: [leadsDataSourceMap.description],

    render: () => ({
        visibility: "permanent",
        filterCardLayout: "full-width",
        tooltipText: { key: leadsSearchFiltersI18nKeys.filterGroupTooltip("countries") },
        filter: new VisitsFromFilterModel({
            initialDtoValue: [settingsService.getWorldwideCountryCodeOrFallback()],
            options: {
                countries: settingsService.getCurrentComponentCountries(),
                regions: settingsService.getRegions(),
            },
        }),
        filterResultView: VisitsFromFilterResult,
        filterCardView: BorderedFilterItemCard,
    }),
});
